import { useRef, } from "react";

export function usePopupWindow() {
  const popupRef = useRef<Window | null>(null,);

  const openPopup = () => {
    popupRef.current = window.open("", "_blank",);

    if (!popupRef.current) {
      throw new Error("Popup blocked",);
    }

    return popupRef.current;
  };

  const setUrl = (url: string) => {
    if (popupRef.current) {
      popupRef.current.location.href = url;
    }
  };

  const writeContent = (html: string) => {
    if (popupRef.current) {
      popupRef.current.document.write(html);
    }
  };

  return {
    openPopup,
    setUrl,
    writeContent,
  };
}
